import React, { useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useVersionStore } from 'store/version.store';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

import { mobileAppConfig } from 'components/Mobile/mobileConfig';

const NoDataFoundMobile = () => {
    const version = useVersionStore((state) => state.version);
    const history = useHistory();

    useEffect(() => {
        if (version !== null) {
            history.replace(AppRoutes.buildPath(AppRoutes.MOBILE, mobileAppConfig.home.link, version.versionHashCode));
        }
    }, [version]);

    return (
        <div className={classes.message}>
            <div className={classes.description}>
                <h1>No programs uploaded yet for this sub-program. Use the non mobile app to upload program files.</h1>
            </div>
        </div>
    );
};
export default NoDataFoundMobile;
